import { createFormDraftStore } from '@/shared/store/formDrafts';
import {
  TRIGGER_DRAFTS_STORAGE_KEY,
  registerPersonalDraftStore,
} from '@/shared/store/personalDrafts';
import type { SheetFormValues } from '../components/TriggerProfileFormSheet';

export { TRIGGER_DRAFTS_STORAGE_KEY };

/**
 * What was typed into a new trigger form and not yet created (spec 124 US2),
 * one draft per workspace. The form holds no secret value — connections and
 * workflows are referenced by id — so nothing is stripped.
 */
export const useTriggerDraftStore = createFormDraftStore<SheetFormValues>({
  storageKey: TRIGGER_DRAFTS_STORAGE_KEY,
});

// Drafts go with the person (spec 197): emptied when someone else signs in here.
registerPersonalDraftStore(() => useTriggerDraftStore.setState({ drafts: {} }));
